import React from 'react';
import { UserPlusIcon, CheckIcon, XMarkIcon, UserIcon } from '@heroicons/react/24/outline';

const PendingRequests = ({ pendingRequests, approveUser, rejectUser }) => {
  return (
    <section className="rounded-lg border border-yellow-200 bg-yellow-50 p-6 shadow-sm">
      <div className="mb-6 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h2 className="text-xl font-semibold text-yellow-900">Pending Registration Requests</h2>
          <p className="mt-1 text-sm text-yellow-700">Review and approve new user registrations</p>
        </div>
      </div>
      {pendingRequests.length === 0 ? (
        <div className="rounded-lg border-2 border-dashed border-yellow-300 p-8 text-center">
          <UserIcon className="mx-auto h-12 w-12 text-yellow-400" />
          <h3 className="mt-2 text-sm font-medium text-yellow-900">No pending requests</h3>
          <p className="mt-1 text-sm text-yellow-700">
            All registration requests have been processed.
          </p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="mobile-table min-w-full divide-y divide-yellow-200">
            <thead className="bg-yellow-100">
              <tr>
                <th className="px-4 py-2 text-left text-xs font-medium uppercase tracking-wider text-yellow-700">
                  ID
                </th>
                <th className="px-4 py-2 text-left text-xs font-medium uppercase tracking-wider text-yellow-700">
                  Name
                </th>
                <th className="px-4 py-2 text-left text-xs font-medium uppercase tracking-wider text-yellow-700">
                  Email
                </th>
                <th className="px-4 py-2 text-left text-xs font-medium uppercase tracking-wider text-yellow-700">
                  Requested Role
                </th>
                <th className="px-4 py-2 text-left text-xs font-medium uppercase tracking-wider text-yellow-700">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-yellow-200">
              {pendingRequests.map((request) => (
                <tr key={request.id}>
                  <td className="whitespace-nowrap px-4 py-2 text-sm text-gray-900" data-label="ID">
                    {request.id}
                  </td>
                  <td
                    className="whitespace-nowrap px-4 py-2 text-sm text-gray-900"
                    data-label="Name"
                  >
                    {request.first_name} {request.last_name}
                  </td>
                  <td
                    className="whitespace-nowrap break-words px-4 py-2 text-sm text-gray-900"
                    data-label="Email"
                  >
                    {request.email}
                  </td>
                  <td
                    className="whitespace-nowrap px-4 py-2 text-sm text-gray-900"
                    data-label="Requested Role"
                  >
                    <span className="capitalize">
                      {request.requested_training_group_role || 'N/A'}
                    </span>
                  </td>
                  <td
                    className="whitespace-nowrap px-4 py-2 text-sm text-gray-900"
                    data-label="Actions"
                  >
                    <div className="flex items-center gap-2">
                      <button
                        className="flex items-center gap-1 rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 transition-colors hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-1"
                        onClick={() =>
                          approveUser(request.id, `${request.first_name} ${request.last_name}`)
                        }
                        title="Approve user"
                      >
                        <CheckIcon className="h-3 w-3" />
                        Approve
                      </button>
                      <button
                        className="flex items-center gap-1 rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 transition-colors hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-1"
                        onClick={() =>
                          rejectUser(request.id, `${request.first_name} ${request.last_name}`)
                        }
                        title="Reject user"
                      >
                        <XMarkIcon className="h-3 w-3" />
                        Reject
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
};

export default PendingRequests;
